import { OverlayButton } from '$components/OverlayButton';
import { useFragment } from '$contentful-gql/fragment-masking';
import { TextRichText } from '$providers/Text';
import { textFragment } from '$providers/common';
import { LayoutContext } from '$root/src/context';
import cn from 'classnames';
import { useContext } from 'react';

export function HeroOverlay(props) {
  const {
    currentPage,
    num,
    overlayText,
    overlayAsset,
    overlayCta,
    overlayButtons,
  } = props;

  const useLayoutStore = useContext(LayoutContext);

  const text = useFragment(textFragment, overlayText);

  const setOverlayOpen = useLayoutStore((state) => state.setOverlayOpen);
  const setOverLayTitle = useLayoutStore((state) => state.setOverLayTitle);
  const setOverLayCopy = useLayoutStore((state) => state.setOverLayCopy);
  const setOverLayAsset = useLayoutStore((state) => state.setOverLayAsset);
  const setStartPosX = useLayoutStore((state) => state.setStartPosX);
  const setStartPosY = useLayoutStore((state) => state.setStartPosY);
  const setOverlayCtaS = useLayoutStore((state) => state.setOverlayCtaS);
  const newHeight = useLayoutStore((state) => state.resized);
  const setOverlayContentOpen = useLayoutStore(
    (state) => state.setOverlayContentOpen,
  );
  const setCallingButton = useLayoutStore((state) => state.setCallingButton);
  const openOverlay = (e) => {
    setOverlayOpen(() => true);
    setOverlayContentOpen(() => true);
    setCallingButton(() => 'overlay');
    //setStartPosX(() => e.clientX - window.innerWidth / 2);
    //setStartPosY(() => -(e.clientY - window.innerHeight / 2));
    setStartPosX(() => e.clientX);
    setStartPosY(() => e.clientY);
    setOverLayTitle(() => (text ? text.title : ''));
    setOverLayAsset(() => (overlayAsset ? overlayAsset : ''));
    setOverLayCopy(
      () => text.richText && <TextRichText json={text.richText?.json} />,
    );
    setOverlayCtaS(() => overlayButtons);
  };

  return (
    <div
      style={{ height: newHeight }}
      className={cn(
        'absolute left-0 top-0 w-full flex flex-col items-center justify-center',
      )}
    >
      <div
        className={cn(
          'absolute h-[72vh] md:h-[85vh] w-[72vh] md:w-[85vh] bg-[length:auto_100vh] md:bg-[length:100vw_auto]',
        )}
      >
        <div
          className={cn(
            currentPage !== num ? 'hidden' : '',
            'absolute right-[50%] -mr-7 -mt-7 md:-mr-0 md:mt-0 md:right-[12%] md:top-[12%]',
          )}
        >
          <OverlayButton
            action={openOverlay}
            title={overlayCta}
            size={'l'}
            type={'dark'}
          />
        </div>
      </div>
    </div>
  );
}
